/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlphabetCyrillic = createReactComponent("outline", "alphabet-cyrillic", "IconAlphabetCyrillic", [["path", { "d": "M6 10h2a2 2 0 0 1 2 2v5h-3a2 2 0 1 1 0 -4h3", "key": "svg-0" }], ["path", { "d": "M19 7h-3a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h1a2 2 0 0 0 2 -2v-3a2 2 0 0 0 -2 -2h-3", "key": "svg-1" }]]);

export { IconAlphabetCyrillic as default };
//# sourceMappingURL=IconAlphabetCyrillic.mjs.map
